import React from "react";

export const APPFOOTER_LANG = (formatMessage) => {
    let MULTI_LANG = {
        LABEL_TITLE_MESSAGE                       : formatMessage({id: "appFooter.title.message", defaultMessage: "메뉴얼 - WINGSCMS에서는 각 메뉴별로 매뉴얼을 보실 수 있습니다. 궁금하신 메뉴를 왼쪽 메뉴바에서 선택해주세요."}),
    }
    
    return MULTI_LANG;
};
